import Boiler from "../boiler/Boiler";
import { TestTakerSettingsProvider } from "../contexts/testTakerSettingsContext";
import { SlideDataProvider } from "../contexts/slideDataContext";
import { TestStoreProvider } from "../contexts/testStoreContext";
import { LangProvider } from "../contexts/langContext";
import { SocketProvider } from "../contexts/websocketContext";
import { SelectAnswerProvider } from "../contexts/selectAnswerContext";
import { QuizModuleProvider } from "@natklok/contexts/quizModuleContext";

import { QueryClient, QueryClientProvider } from "@tanstack/react-query";

const queryClient = new QueryClient();

const Contexts = () => {
  return (
    <QueryClientProvider client={queryClient}>
      <LangProvider>
        <TestStoreProvider>
          <TestTakerSettingsProvider>
            <SlideDataProvider>
              <QuizModuleProvider>
                <SocketProvider>
                  <SelectAnswerProvider>
                    <Boiler />
                  </SelectAnswerProvider>
                </SocketProvider>
              </QuizModuleProvider>
            </SlideDataProvider>
          </TestTakerSettingsProvider>
        </TestStoreProvider>
      </LangProvider>
    </QueryClientProvider>
  );
};

export default Contexts;
